// src/components/Header.js
import React from 'react';
import '../styles/headerr.css';

const Headerr = ({ user, onLogout, onMenuToggle }) => {
  return (
    <header className="header">
      <div className="header-left">
        <button className="menu-toggle" onClick={onMenuToggle}>
          <i className="icon-menu"></i>
        </button>
        <h1>Admin Dashboard</h1>
      </div>
      
      <div className="header-right">
        <div className="user-menu">
          <span className="welcome-message">Welcome, {user?.first_name || 'Admin'}</span>
          <button onClick={onLogout} className="logout-btn">
            <i className="icon-logout"></i> Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Headerr;